/**
 * BCE Service Table Maintenance Module
 *
 * Responsive maintenance package comparison table with accordion functionality
 * Controlled by BCE.init() system
 *
 * @class BceServiceTableMaintenance
 */
class BceServiceTableMaintenance {
	constructor() {
		this.instances = new WeakMap();
		this.autoInit = false; // Controlled by BCE system
	}

	/**
	 * Initialize all maintenance tables found in the DOM
	 * Automatically called by BCE system on page load
	 */
	init() {
		console.log('BCE Service Table Maintenance: init() called');
		const containers = document.querySelectorAll('.bce_service-table-maintenance');
		console.log('BCE Service Table Maintenance: found', containers.length, 'containers');
		containers.forEach((container) => {
			if (!this.instances.has(container)) {
				this.create(container);
			}
		});
	}

	/**
	 * Create a maintenance table instance
	 * @param {HTMLElement} element - Container element (.bce_service-table-maintenance)
	 * @returns {Object|null} Instance object or null
	 */
	create(element) {
		console.log('BCE Service Table Maintenance: create() called', element);

		if (this.instances.has(element)) {
			console.log('BCE Service Table Maintenance: instance already exists');
			return this.instances.get(element);
		}

		// Find all accordion toggles within this table
		const accordionToggles = element.querySelectorAll('.accordion-toggle');
		console.log('BCE Service Table Maintenance: found', accordionToggles.length, 'toggles');

		if (accordionToggles.length === 0) {
			return null;
		}

		// Create click handlers for each toggle
		const handlers = new Map();
		accordionToggles.forEach((toggle) => {
			const handler = () => this.toggleAccordion(toggle);
			toggle.addEventListener('click', handler);
			handlers.set(toggle, handler);
		});

		// Create instance
		const instance = {
			element,
			accordionToggles,
			handlers,
			destroy: () => {
				// Remove all event listeners
				handlers.forEach((handler, toggle) => {
					toggle.removeEventListener('click', handler);
				});
				this.instances.delete(element);
			}
		};

		this.instances.set(element, instance);
		return instance;
	}

	/**
	 * Toggle accordion state
	 * @param {HTMLElement} toggle - Accordion toggle element
	 */
	toggleAccordion(toggle) {
		const content = toggle.nextElementSibling;

		if (!content || !content.classList.contains('accordion-content')) {
			return;
		}

		toggle.classList.toggle('active');
		content.classList.toggle('active');
	}

	/**
	 * Get instance for external access
	 * @param {HTMLElement} element - Container element
	 * @returns {Object|null} Instance object or null
	 */
	getInstance(element) {
		return this.instances.get(element) || null;
	}

	/**
	 * Destroy instance and clean up
	 * @param {HTMLElement} element - Container element
	 */
	destroy(element) {
		const instance = this.instances.get(element);
		if (instance && instance.destroy) {
			instance.destroy();
		}
	}
}

export default new BceServiceTableMaintenance();
